import { LotusMark } from "./LotusMark";

export const Footer = () => (
  <footer className="border-t border-[var(--gt-line)] py-16 bg-[var(--gt-surface)]">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-3">
          <LotusMark size={28} />
          <span className="font-serif text-lg text-[var(--gt-ivory)]">
            The Golden Touch <span className="text-[var(--gt-muted)] italic">by Marisol</span>
          </span>
        </div>
        <div className="flex items-center gap-8 gt-eyebrow">
          <a href="tel:2109989393" className="gt-link hover:text-[var(--gt-ivory)]">210 · 998 · 9393</a>
          <span className="gt-gold-text">10+ Years Experience</span>
        </div>
      </div>
      <p className="mt-10 text-center md:text-left text-xs tracking-wide text-[var(--gt-muted)]">
        © {new Date().getFullYear()} The Golden Touch by Marisol. Custom massage for the body, mind and soul.
      </p>
    </div>
  </footer>
);
